import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Card } from '../ui/Card';
import { ARTICLES_BY_SLUG } from '../../config/blogArticles';

interface RelatedArticlesProps {
  slugs: string[];
}

export function RelatedArticles({ slugs }: RelatedArticlesProps) {
  const articles = slugs
    .map((slug) => ARTICLES_BY_SLUG[slug])
    .filter((a): a is NonNullable<typeof a> => Boolean(a));

  if (articles.length === 0) return null;

  return (
    <section className="mb-14">
      <h2 className="text-2xl font-serif font-bold text-foreground mb-6">
        Related articles
      </h2>
      <div className="grid gap-4 md:grid-cols-3">
        {articles.map((article) => (
          <Link
            key={article.slug}
            to={`/blog/${article.slug}`}
            className="group block"
          >
            <Card className="h-full p-5 hover:shadow-md transition-shadow">
              <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors mb-2">
                {article.shortTitle}
              </h3>
              <p className="text-sm text-muted-foreground mb-3 line-clamp-3">
                {article.excerpt}
              </p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-primary">
                Read <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </Card>
          </Link>
        ))}
      </div>
    </section>
  );
}
